import ColorsContainer from './ColorsContainer.container';

export default ColorsContainer;
